import { combineReducers } from "redux"
import { fetchData } from "./fetch-data"
import { currentEditingState } from "./current-editing-data"

export const editor = combineReducers({
  fetchData,
  currentEditingState,
})
